'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var styled = require('@emotion/styled');
var coreRenderer = require('@tempi/core-renderer');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ContentSliderItem = React__default["default"].forwardRef(({ children, commonStyle }, ref) => {
  return /* @__PURE__ */ jsxRuntime.jsx(StyledDiv, {
    commonStyle,
    ref,
    children
  });
});
const StyledDiv = styled__default["default"].div(
  ({ commonStyle }) => `
    ${coreRenderer.getStyle(commonStyle)}
  `
);
ContentSliderItem.displayName = "ContentSliderItem";

exports.ContentSliderItem = ContentSliderItem;
